import { useState } from "react";
import styles from "./MenuLayoutEdit.module.css";

export default function ButtonGrid(props) {
  const { buttons, onEdit, onDelete, onDrop } = props;

  const onDragStart = (ev, buttonIndex) => {
    ev.dataTransfer.setData("buttonIndex", buttonIndex);
    ev.dataTransfer.dropEffect = "move";
  };

  const onDragOver = (ev) => {
    ev.preventDefault();
  };

  const sortedButtons = (buttons || []).sort(function (a, b) {
    const valueA = `${a.rowIndex}-${a.columnIndex}`;
    const valueB = `${b.rowIndex}-${b.columnIndex}`;
    if(valueA > valueB) {
      return 1;
    }
    if(valueA < valueB) {
      return -1;
    }
    return 0;
  });
  
  let row = [];
  const rows = [];
  let currentRowIndex = 0;
  for(let i = 0; i < sortedButtons.length; i++) {
    const rowIndex = sortedButtons[i].rowIndex || 0;
    const button = sortedButtons[i];
    if(rowIndex > currentRowIndex) {
      rows.push(<tr key={currentRowIndex}>{row}</tr>);
      row = [];
      currentRowIndex = rowIndex;
    }
    row.push(
        <td key={i}
            rowSpan={button.rowSpan}
            colSpan={button.columnSpan}
            style={{
              height:"120px",
              overflow:"hidden"
            }}>
        <div
          style={{
            padding: "10px",
            height: "100%",
            minWidth: "150px",
            backgroundColor: (button && button.color) || "gray",
            margin: "0 5px 5px 0",
            overflow: "hidden",
            cursor: "pointer",
          }}
          role="button"
          aria-label={`Edit ${
            button.id
              ? `button for ${button.itemName} ${button.categoryName}`
              : `empty button ${i + 1}`
          }`}
          onClick={(e) => {
            e.preventDefault();
            onEdit(i);
          }}
          draggable={button && button.itemName ? true : false}
          className={button && button.itemName ? "draggable droppable" : ""}
          onDragStart={(e) => onDragStart(e, i)}
          onDragOver={(e) => onDragOver(e)}
          onDrop={(e) => onDrop(e, i, button)}
        >
          {button && button.itemName && (
            <span
              className="k-icon k-i-trash pull-right"
              role="button"
              aria-label={`Delete button for ${button.itemName} ${button.categoryName}`}
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onDelete(i);
              }}
            />
          )}
          <h3 className={styles.buttonItemName}>
            {button && (button.buttonCaption || button.itemName)}
          </h3>
          <h4 className={styles.buttonCategoryName}>
            {button && button.categoryName}
          </h4>
        </div>
      </td>
    );
  }
  rows.push(<tr key={currentRowIndex}>{row}</tr>);
  
  return (
    <table>
      <tbody>{rows}</tbody>
    </table>
  );
}